import { render, staticRenderFns } from "./HotelBookings.vue?vue&type=template&id=346a17b6&scoped=true"
import script from "./HotelBookings.vue?vue&type=script&lang=js"
export * from "./HotelBookings.vue?vue&type=script&lang=js"
import style0 from "./HotelBookings.vue?vue&type=style&index=0&id=346a17b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a17b6",
  null
  
)

export default component.exports